export default import.meta.ROLLDOWN_FILE_URL_2o2zU0lD3fmgn3MOGobWsw